import { useAuth0 } from "@auth0/auth0-react";
import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { Api } from "../general/api";

export const ApiContext = createContext<Api | null>(null);

export function useApi() {
  const context = useContext(ApiContext);
  
  // Return the API if it exists, or throw a clean error
  if (context === undefined) {
    console.log("useApi must be used inside ApiProvider");
  }
  
  if (context === null) {
    // This allows components to handle the loading state gracefully
    console.log("API is initializing. Please wait for Auth0.");
  }
  
  return context;
}

export function ApiProvider({ children }: PropsWithChildren) {
  const { getAccessTokenSilently, loginWithRedirect, getIdTokenClaims, isAuthenticated, isLoading } = useAuth0();

  const api = useMemo(() => {
    if (isLoading) return null;
    return new Api(getAccessTokenSilently, loginWithRedirect, getIdTokenClaims);
  }, [getAccessTokenSilently, loginWithRedirect, getIdTokenClaims, isLoading]);

  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
}